import Setup from "../../../container/setup/index";
import BillOfMaterials from "../../../container/setup/BillOfMaterials";
import CPChecklist from "../../../container/setup/CPChecklistComponent";
import QCChecklist from "../../../container/setup/QualityChecklist";
import Laydown from "../../../container/setup/LaydownAndScope";

import ConstructionProgress from "../../../container/setup/ConstructionProgress";
import ScopeAllocatedPerLaydownContainer from "../../../container/reports/ScopeAllocatedPerLaydown";

const setupRoute = [
  {
    path: "setup",
    element: <Setup />,
  },
  {
    path: "setup/bill-of-material",
    element: <BillOfMaterials />,
  },
  {
    path: "setup/cp-checklist",
    element: <CPChecklist />,
  },
  {
    path: "setup/qc-checklist",
    element: <QCChecklist />,
  },
  {
    path: "setup/laydown-and-scope",
    element: <Laydown />,
  },
  {
    path: "setup/laydown-and-scope/:laydownId/scope",
    element: <Laydown />,
  },
  {
    path: "setup/laydown-and-scope/:laydownId/laydown",
    element: <Laydown />,
  },
  {
    path: "setup/construction-progress-sequence",
    element: <ConstructionProgress />,
  },
  {
    path:"setup/laydown-and-scope/scope-allocated-per-laydown",
    element:<ScopeAllocatedPerLaydownContainer />
  }
];

export default setupRoute;
